import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isBootFeatureEnabled } from 'owa-metatags';

export function isMonarchAccountManagementEnabled(): boolean {
    return isHostAppFeatureEnabled('acctmonaccounts') && isBootFeatureEnabled('acctmonaccounts');
}

/**
 * To making the coding for multiple accounts easier this check is used to determine if
 * the API for multiple accounts should be enabled. This will return true when we are either
 * in Monarch with full multiple account support or if we are not in monarch and the 'accountsapi'
 * feature is enabled.
 * @returns true if the API for multiple accounts should be enabled
 */
export function isMonarchMultipleAccountsEnabled(): boolean {
    return (
        isMonarchAccountManagementEnabled() ||
        (!isHostAppFeatureEnabled('acctmonaccounts') && isBootFeatureEnabled('accountsapi'))
    );
}
